import { computed } from '@vue/composition-api';

function getPlatform() {
    if (/android/i.test(navigator.userAgent)) {
        return 'android';
    }
    else if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
        return'ios';
    }
    return 'web';
}

export function usePlatformChecker() {
    return {
        getPlatform: computed(() => getPlatform()),
        platformIsAndroid: computed(() => getPlatform() == 'android'),
        platformIsIos: computed(() => getPlatform() == 'ios'),
        platformIsWeb: computed(() => getPlatform() == 'web')
    }
}
